var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",attrs:{"id":"editAbsenteeism"}},[_c('MainBarMenuV2'),_c('b-container',{staticClass:"container-fluid"},[_c('b-row',[_vm._v(" HOLA ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }